import { Component } from 'react';
import PropTypes from 'prop-types';

class ErrorComponent extends Component {
  render() {
    const { errors } = this.props;

    if (!Array.isArray(errors) || errors.length < 1) {
      return null;
    }

    const errorItems = errors.map(error => <li key={error}>{error}</li>);

    return (
      <ul className="errors col-md-12 col-xs-12">
        {errorItems}
      </ul>
    );
  }
}

ErrorComponent.propTypes = {
  errors: PropTypes.oneOfType([
    PropTypes.array,
    PropTypes.bool,
  ]),
};

ErrorComponent.defaultProps = {
  errors: null,
};

export default ErrorComponent;
